import { Control } from 'react-hook-form'
import { Panel } from '@/ui/atoms/panel/Panel'
import { Typography } from '@/ui/atoms/typography/Typography'
import { ControlledMultiSelectorAssetInput } from '@/ui/organisms/multi-selector/ControlledMultiSelectorAssetInput'
import { BridgeFormSchema, BridgeToken, SwapMode } from '@/features/bridge/logic/useBridge'
import { TokenSymbol } from '@/domain/types/TokenSymbol'
import { NormalizedUnitNumber } from '@/domain/types/NumericValues'
import { Info } from '@/ui/molecules/info/Info'
import { SearchableAssetSelector } from '@/ui/molecules/searchable-asset-selector/SearchableAssetSelector'

interface FromProps {
  control: Control<BridgeFormSchema>
  assets: BridgeToken[]
  selectedAsset: BridgeToken
  maxSelectedFieldName?: string
  maxValue: NormalizedUnitNumber
  changeToken: (newSymbol: TokenSymbol) => void
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  onSetMax?: (max: NormalizedUnitNumber) => void
  swapMode: SwapMode
}

export function From(props: FromProps) {
  const { control, assets, selectedAsset, maxSelectedFieldName, changeToken, onChange, onSetMax, maxValue, swapMode } =
    props

  // Calculate which balance to display based on direction
  const balanceToDisplay = swapMode === 'bridgeToHyperEVM' ? selectedAsset.l1Balance : selectedAsset.balance
  const sourceNetwork = swapMode === 'bridgeToHyperEVM' ? 'HyperCore' : 'HyperEVM'

  return (
    <Panel.Wrapper className="mt-2 p-4 pb-5">
      <div className="flex flex-row items-center gap-1">
        <Typography variant="h4" className="py-3 font-semibold">
          From {sourceNetwork}
        </Typography>
        {swapMode === 'bridgeToHyperEVM' && <Info>HyperCore is name of the Hyperliquid Exchange</Info>}
      </div>

      <div>
        <div className="mt-2 flex flex-row items-start gap-2">
          <ControlledMultiSelectorAssetInput
            fieldName="from.value"
            control={control}
            disabled={false}
            token={selectedAsset.token}
            resetBorrowStatus={() => {}}
            max={maxValue}
            balance={balanceToDisplay}
            maxSelectedFieldName={maxSelectedFieldName}
            customOnChange={onChange}
            onSetMax={onSetMax}
          />

          <SearchableAssetSelector
            assets={assets}
            selectedAsset={selectedAsset.token}
            setSelectedAsset={changeToken}
            isL1={swapMode === 'bridgeToHyperEVM'}
            swapMode={swapMode}
            isDestination={false}
          />
        </div>
      </div>
    </Panel.Wrapper>
  )
}
